// CSS
require("bootstrap/dist/css/bootstrap.css")
require("jquery-ui/themes/base/all.css")
require("datatables.net-responsive-dt/css/responsive.dataTables.css")
require("font-awesome/css/font-awesome.css")
require("fullcalendar/dist/fullcalendar.css")
require("angularjs-slider/dist/rzslider.css")

// IE11 (10?) Support
require("@babel/polyfill")

// JQuery
var $ = require("jquery")
window.$ = $
window.jQuery = $

// JQuery UI - Create Graphic Message
require("jquery-ui/ui/widget")
require("jquery-ui/ui/widgets/dialog")
require("jquery-ui/ui/data")
require("jquery-ui/ui/focusable")
require("jquery-ui/ui/keycode")
require("jquery-ui/ui/position")
require("jquery-ui/ui/safe-active-element")
require("jquery-ui/ui/safe-blur")
require("jquery-ui/ui/tabbable")
require("jquery-ui/ui//unique-id")

// Misc Libraries
window.moment = require("moment")
require("moment-timezone")
window.Clipboard = require("clipboard")
require("fullcalendar")

// WMCanvas
window.Konva = require("konva")

// UI
require("bootstrap")

// DataTables
require("datatables.net")(window, $)
require("datatables.net-responsive")(window, $)

// AngularJS
require("angular")

require("angular-animate")
require("angular-cookies")
require("angular-datatables")
require("angular-file-saver")
require("angular-filter")
require("angular-google-chart")

require("angular-ui-bootstrap")
require("angular-ui-calendar")
require("angular-ui-mask")
require("angular-ui-router")
require("angularjs-slider")

// PubNub
var pubnub = require("pubnub")
window.Pubnub = pubnub

window.FMMessage = require("fm-message")

// Paper
// window.paper = require("paper")

// Google Map Clusters
window.MarkerClusterer = require("@googlemaps/markerclustererplus").default
